import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface AuthState {
  isLoggedIn: boolean;
  account: Account | null;
  accessToken: string | null;
  refreshToken: string | null;

  login: (account: Account, accessToken: string, refreshToken: string) => void;
  logout: () => void;
}

const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      isLoggedIn: false,
      account: null,
      accessToken: null,
      refreshToken: null,

      login: (account, accessToken, refreshToken) =>
        set({
          isLoggedIn: true,
          account,
          accessToken,
          refreshToken
        }),
      logout: () =>
        set({
          isLoggedIn: false,
          account: null,
          accessToken: null,
          refreshToken: null
        })
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
);

export default useAuth;
